/* unplugin-vue-components disabled */import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import PopupPicker from "vux/src/components/popup-picker/index.vue"; // this line is trasformed by vux-loader
import PopupRadio from "vux/src/components/popup-radio/index.vue"; // this line is trasformed by vux-loader
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import XInput from "vux/src/components/x-input/index.vue"; // this line is trasformed by vux-loader
import XButton from "vux/src/components/x-button/index.vue"; // this line is trasformed by vux-loader
import Datetime from "vux/src/components/datetime/index.vue"; // this line is trasformed by vux-loader
import XSwitch from "vux/src/components/x-switch/index.vue"; // this line is trasformed by vux-loader
import ChinaAddressV4Data from "vux/src/datas/china_address_v4.json"; // this line is trasformed by vux-loader
import XTextarea from "vux/src/components/x-textarea/index.vue"; // this line is trasformed by vux-loader
import Checklist from "vux/src/components/checklist/index.vue"; // this line is trasformed by vux-loader
import TransferDom from "vux/src/directives/transfer-dom/index.js"; // this line is trasformed by vux-loader
import Cell from "vux/src/components/cell/index.vue"; // this line is trasformed by vux-loader
import CellBox from "vux/src/components/cell-box/index.vue"; // this line is trasformed by vux-loader
import Popup from "vux/src/components/popup/index.vue"; // this line is trasformed by vux-loader
import SinglePicker from '@/components/Base/SinglePicker';
import CheckProduct from './CheckProduct';
import { throttle } from 'lodash';
import { getProductGetIdByProductionSn, getCustomerProductDetail, getCustomerProductionService } from '@/api';
import ModalScan from './ModalScan';
import { Html5Qrcode } from 'html5-qrcode';
import ExtFieldPc from '@/components/ExtFieldPc.vue';
export default {
  components: {
    ExtFieldPc: ExtFieldPc,
    ViewBox: ViewBox,
    ModalScan: ModalScan,
    PopupPicker: PopupPicker,
    PopupRadio: PopupRadio,
    Group: Group,
    XInput: XInput,
    XButton: XButton,
    Datetime: Datetime,
    XSwitch: XSwitch,
    ChinaAddressV4Data: ChinaAddressV4Data,
    XTextarea: XTextarea,
    Checklist: Checklist,
    TransferDom: TransferDom,
    Cell: Cell,
    CellBox: CellBox,
    Popup: Popup,
    SinglePicker: SinglePicker,
    CheckProduct: CheckProduct
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    selectCustomerId: {
      type: [String, Number],
      default: ''
    },
    showMask: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      customField: [],
      isShowScan: false,
      showScan: false,
      storehouse_type: 0,
      currValue: this.value,
      warrantyList: [{
        name: i18n.tc("213"),
        value: '1'
      }, {
        name: i18n.tc("214"),
        value: '2'
      }, {
        name: i18n.tc("215"),
        value: '3'
      }],
      isAddProductModal: false,
      isShowSelectProductModal: false,
      form: {},
      codeMap: {}
    };
  },
  computed: {
    // 计算滚动区域高度
    scrollerHight: function scrollerHight() {
      var fontSize = window.getComputedStyle(window.document.documentElement)['font-size'];
      fontSize = Number(fontSize.substr(0, fontSize.length - 2));
      return document.documentElement.clientHeight - (4 + 4 + 0.8) * fontSize;
    },
    DingTalk: function DingTalk() {
      return this.$DingTalk;
    }
  },
  watch: {
    value: function value(val) {
      this.currValue = val;
    },
    currValue: function currValue(val) {
      var _this = this;
      if (val) {
        this.$setLeft({
          control: true,
          onSuccess: function onSuccess() {
            _this.currValue = false;
          }
        });
      } else {
        this.$setLeft({
          control: false
        });
      }
      this.form = {
        customerProId: '',
        purchasing_date: '',
        productName: '',
        productId: '',
        productionSn: '',
        productionTypeId: ''
      };
      this.customField = [];
      this.$emit('input', val);
    }
  },
  methods: {
    getCamera: function getCamera() {
      var _this2 = this;
      Html5Qrcode.getCameras().then(function (devices) {
        console.log('AutoConsole: getCamera -> devices', devices);
        if (devices && devices.length) {
          _this2.isShowScan = true;
        }
      }).catch(function (e) {
        console.log(e);
      });
    },
    handleBackResult: function handleBackResult(ev) {
      this.form.productionSn = ev;
    },
    handleSearch: throttle(function (sn) {
      this.getProductDetail(sn);
    }, 1000, {
      leading: false,
      trailing: true
    }),
    getProductDetail: function getProductDetail() {
      var _arguments = arguments,
        _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var query, res, pro, customerPro;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                query = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : '';
                if (query) {
                  _context.next = 3;
                  break;
                }
                return _context.abrupt("return", console.log('产品档案 is null'));
              case 3:
                _this3.$vux.toast.text(i18n.tc("569"));
                _context.next = 6;
                return getProductGetIdByProductionSn({
                  production_sn: query
                });
              case 6:
                res = _context.sent;
                if (!res.data.cpId) {
                  _context.next = 14;
                  break;
                }
                _context.next = 10;
                return getCustomerProductDetail({
                  customerProductionId: res.data.cpId
                });
              case 10:
                pro = _context.sent;
                if (pro.success) {
                  customerPro = pro.data.customerPro;
                  _this3.form = {
                    customerProId: customerPro.id,
                    productName: customerPro.product_name,
                    productId: customerPro.fk_t_production_id,
                    productionSn: customerPro.production_sn,
                    productionTypeId: customerPro.typeId,
                    install_date: customerPro.install_date,
                    warranty_start_date: customerPro.warranty_start_date,
                    warranty_end_date: customerPro.warranty_end_date,
                    purchasing_date: customerPro.purchasing_date,
                    delivery_date: customerPro.delivery_date,
                    production_date: customerPro.production_date,
                    warranty_type: customerPro.warrantyState
                  };
                  _this3.customField = pro.data.fvs || [];
                }
                _context.next = 15;
                break;
              case 14:
                _this3.$vux.toast.text(i18n.tc("570"));
              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    selectProduct: function selectProduct(e) {
      var selectionObj = this.form;
      selectionObj.productName = e.name;
      selectionObj.productId = e.id;
      selectionObj.productionTypeId = e.fk_t_production_category_id;
    },
    // 获取产品名称
    getProductName: function getProductName() {
      if (!this.form.customerProductionId) {
        this.isShowSelectProductModal = true;
      }
    },
    submit: function submit() {
      if (!this.form.productId) return this.$vux.toast.text(i18n.tc("220"));
      // if (!this.form.purchasing_date) return this.$vux.toast.text('请选择购买时间')
      this.$emit('on-success', this.form);
      this.currValue = false;
    },
    scan: function scan() {
      var _this4 = this;
      this.$DingTalk && this.$DingTalk.biz.util.scan({
        type: 'all',
        tips: i18n.tc("491"),
        onSuccess: function onSuccess(res) {
          var _res$text;
          console.log('AutoConsole: scan -> res', res);
          var code = '';
          if (res !== null && res !== void 0 && (_res$text = res.text) !== null && _res$text !== void 0 && _res$text.includes(',')) {
            code = res.text.split(',')[1];
          } else {
            code = res.text || '';
          }
          _this4.form.productionSn = code.trim();
          _this4.getProductDetail(code.trim());
        },
        onFail: function onFail(e) {
          console.log('scan error');
        }
      });
    }
  },
  created: function created() {
    var _this5 = this;
    this.getCamera();
    getCustomerProductionService().then(function (res) {
      if (res.success) {
        res.data.forEach(function (val) {
          _this5.$set(_this5.codeMap, val.code, val.value);
        });
      }
    });
  }
};